/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import Styles from "./wechatDialog.module.scss";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import UKImg from "@/common-components-src/components/UKImg";
import JDIPrice from "@/common-components-src/js/price/index";
import Countdown from "@/common-components-src/js/countdown/index";
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import QrCode from "react-qr-code";

interface WechatDialogProps {
  //   orderId: string;
  open: boolean;
  onClose: () => void;
  wechatUrl: string;
  // 倒计时时间 单位s
  cuntdownTime: number;
  //   onFresh?: () => void;
}

const WechatDialog = observer((props: WechatDialogProps) => {
  const { t } = useTranslation();
  const { checkoutStore } = useStores();
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    setIsOpen(props.open);
  }, [props.open]);

  return (
    <>
      <UKDialog
        open={isOpen}
        onClose={(e: any, reason: string) => {
          if (reason !== "backdropClick") {
            props.onClose();
          }
        }}
        showCloseBtn={true}
        className={Styles.wechetDialogBox}
        onBackdropClick={(e: any) => {
          e.stopPropagation();
        }}
        sx={{
          "& .MuiDialog-paper": {
            width: "680px", // 设置自定义宽度
            maxWidth: "none", // 取消最大宽度限制
            maxHeight: "480px",
            minHeight: "480px",
          },
        }}
      >
        <DialogTitle className={Styles.wechetDialogTitle}>
          {t("checkout.wechatPay.title")}
        </DialogTitle>
        <DialogContent className={Styles.wechetDialogContent}>
          <div className={Styles.leftBox}>
            <div className={Styles.countdownBox}>
              <div className={Styles.countdownLabel}>Time left to pay:</div>
              <Countdown
                countdown={props.cuntdownTime * 1000}
                onEnd={props.onClose}
                format="mm:ss"
                style={{
                  fontFamily: "JDZhengHT-EN",
                  fontSize: "18px",
                  lineHeight: "22px",
                  color: "#CC0C1C",
                }}
              ></Countdown>
            </div>
            <div className={Styles.orderDetailBox}>
              <div className={Styles.labelBox}>
                <div className={Styles.main}>{t("checkout.wechatPay.orderTotal")}</div>
                <div className={Styles.sub}>{t("checkout.wechatPay.subOrderTotal")}</div>
              </div>
              <div className={Styles.priceInfo}>
                <JDIPrice
                  symbol={checkoutStore.currencySymbol}
                  price={checkoutStore.orderPaymentPrice}
                  uiType={1}
                  containerStyle={{
                    fontSize: "18px",
                    lineHeight: "24px",
                    height: "24px",
                    color: "#CC0C1C",
                  }}
                  integerStyle={{
                    fontSize: "18px",
                    lineHeight: "24px",
                    height: "24px",
                  }}
                />
              </div>
            </div>

            <div className={Styles.wechatQrCodeBox}>
              <QrCode value={props.wechatUrl} size={220} bgColor="#ffffff" fgColor="#000000" />
            </div>
            <div className={Styles.scanTip}>
              <div>{t("checkout.wechatPay.scanTip1")}</div>
              <div>{t("checkout.wechatPay.scanTip2")}</div>
            </div>
          </div>
          <div className={Styles.rightBox}>
            <UKImg
              url="https://st.joy-sourcing.com/website/other/wechatPay.png"
              externalMaskStyles={{ background: "rgba(0, 0, 0, 0)" }}
            />
          </div>
        </DialogContent>
      </UKDialog>
    </>
  );
});

export default WechatDialog;
